import { render, staticRenderFns } from "./PurchasesInvoiceViewDetailsPurchasesInvoiceItemTable.vue?vue&type=template&id=856b12ea"
import script from "./PurchasesInvoiceViewDetailsPurchasesInvoiceItemTable.vue?vue&type=script&lang=js"
export * from "./PurchasesInvoiceViewDetailsPurchasesInvoiceItemTable.vue?vue&type=script&lang=js"
import style0 from "./PurchasesInvoiceViewDetailsPurchasesInvoiceItemTable.vue?vue&type=style&index=0&id=856b12ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports